import {
  SURVEY_LAYERS,
  SURVEY_NUTRIENT_LAYERS,
  SURVEY_TEXTURE_LAYERS,
} from '../../constants/SurveyLayers';

export const FIELD_STATISTICS_COLUMNS = Object.freeze({
  FIELD: 'FIELD',
  AREA: 'AREA',
  CROP: 'CROP',
  CROP_VARIETY: 'CROP_VARIETY',
  SOWING_DATE: 'SOWING_DATE',
});

export const FIELD_STATISTICS_CLAAS_COLUMNS = Object.freeze({
  HARVEST_DATE_CLAAS: 'HARVEST_DATE_CLAAS',
  YIELD_TOTAL_CLAAS: 'YIELD_TOTAL_CLAAS',
  YIELD_AVERAGE_CLAAS: 'YIELD_AVERAGE_CLAAS',
  CROP_MOISTURE_CLAAS: 'CROP_MOISTURE_CLAAS',
  FUEL_CONSUMPTION_CLAAS: 'FUEL_CONSUMPTION_CLAAS',
});

export const FIELD_STATISTICS_EXATREK_COLUMNS = Object.freeze({
  HARVEST_DATE_EXATREK: 'HARVEST_DATE_EXATREK',
  YIELD_TOTAL_EXATREK: 'YIELD_TOTAL_EXATREK',
  YIELD_AVERAGE_EXATREK: 'YIELD_AVERAGE_EXATREK',
  CROP_MOISTURE_EXATREK: 'CROP_MOISTURE_EXATREK',
  FUEL_CONSUMPTION_EXATREK: 'FUEL_CONSUMPTION_EXATREK',
});

export const FIELD_STATISTICS_FIELD_COLUMNS = Object.freeze([FIELD_STATISTICS_COLUMNS.AREA]);

export const FIELD_STATISTICS_SEASON_COLUMNS = Object.freeze([
  FIELD_STATISTICS_COLUMNS.CROP,
  FIELD_STATISTICS_COLUMNS.CROP_VARIETY,
  FIELD_STATISTICS_COLUMNS.SOWING_DATE,
  FIELD_STATISTICS_CLAAS_COLUMNS.HARVEST_DATE_CLAAS,
  FIELD_STATISTICS_CLAAS_COLUMNS.YIELD_TOTAL_CLAAS,
  FIELD_STATISTICS_CLAAS_COLUMNS.YIELD_AVERAGE_CLAAS,
  FIELD_STATISTICS_CLAAS_COLUMNS.CROP_MOISTURE_CLAAS,
  FIELD_STATISTICS_CLAAS_COLUMNS.FUEL_CONSUMPTION_CLAAS,
  FIELD_STATISTICS_EXATREK_COLUMNS.HARVEST_DATE_EXATREK,
  FIELD_STATISTICS_EXATREK_COLUMNS.YIELD_TOTAL_EXATREK,
  FIELD_STATISTICS_EXATREK_COLUMNS.YIELD_AVERAGE_EXATREK,
  FIELD_STATISTICS_EXATREK_COLUMNS.CROP_MOISTURE_EXATREK,
  FIELD_STATISTICS_EXATREK_COLUMNS.FUEL_CONSUMPTION_EXATREK,
]);

export const FIELD_STATISTICS_SECTIONS = {
  FIELD_STATISTICS_FIELD_COLUMNS,
  FIELD_STATISTICS_SEASON_COLUMNS,
  SURVEY_NUTRIENT_LAYERS,
  SURVEY_TEXTURE_LAYERS,
};

export const getColumnName = (column, langFile) => {
  if (Object.keys(SURVEY_LAYERS).includes(column)) {
    let text = `${langFile.SurveyLayers[column].name}`;
    const short = langFile.SurveyLayers[column].shorthand;
    if (short) {
      text += ` (${short})`;
    }
    return text;
  } else if (Object.keys(FIELD_STATISTICS_COLUMNS).includes(column)) {
    return langFile.FieldStatisticsColumn[column];
  } else if (Object.keys(FIELD_STATISTICS_CLAAS_COLUMNS).includes(column)) {
    return langFile.FieldStatisticsColumn[column];
  } else if (Object.keys(FIELD_STATISTICS_EXATREK_COLUMNS).includes(column)) {
    return langFile.FieldStatisticsColumn[column];
  }
  return null;
};
